<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>Patricio Ramos y Ortega, combatiente y pintor</h2>
    <img @click="imageClicked(0)" src="galerias/sala2/S2_G9.jpg" class="mainphoto"/>
    <p class="photo-description">Título: <b>Victoria de los mexicanos</b><br>
      Autor: Patricio Ramos Ortega<br>
      Año: 1862<br>
      Técnica: Óleo sobre tela<br>
      Medidas: 78 x 96 cm.<br>
      Colección Museo de Historia Mexicana<br>
    </p>
    <p>Patricio Ramos Ortega, pintor poblano, (Puebla 1836 - México 1906), participó activamente como parte del Ejército de Oriente en la Batalla del 5 de Mayo de 1862. Sus ojos captaron, uno a uno los detalles: los embates de los zuavos arrogantes, el ataque incontenible de los indígenas serranos que los hicieron desbandarse. El valor a toda prueba de los infantes y artilleros y, el espectacular embate de la caballería nacional rematando al enemigo. Todo eso lo plasmó con extraordinaria técnica y gran realismo -a petición del General Díaz- en varios lienzos que son el mejor testimonio visual del glorioso acontecimiento.</p>
    <p>Su doble mirada, como artista, pero también como combatiente, hacen que su obra tenga un valor diferenciador de otras representaciones posteriores de esta batalla. Además, no solamente dejó plasmado su testimonio en pinturas, sino que también escribió sus memorias para la posteridad. En la imagen se observa el autorretrato de Patricio Ramos vestido de color café.</p>
    <h5>Ver más:</h5>
    <p>
      Fuente de la imagen:<br>
      <a target="_blank" href="https://www.3museos.com/?pieza=batalla-de-puebla">www.3museos.com</a>
     </p>
     <p>
      Memorias de Patricio Ramos:<br>
      <a target="_blank" href="http://bdmx.mx/documento/galeria/ramosyortega-palafoxiana/co_c0053-16/fo_ramos-ortega">bdmx.mx</a>
    </p>
  </div>
</template>

<script>
export default {
  name: "s22g09",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    },
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
